import client from './client';
import publicClient from './publicClient';
import { normalizeTrainingEntryTypeOptions } from '../config/trainingEntryTypeOptions';

export function getMyHours(year) {
  return client.get(`/api/training/my-hours?year=${year}`);
}

export function addTrainingHours(data) {
  return client.post('/api/training/add', data);
}

export function updateTrainingHours(id, data) {
  return client.put(`/api/training/${id}`, data);
}

export function getTrainingEntryEditContext(id) {
  return client.get(`/api/training/${id}/edit-context`);
}

export function fullEditTrainingEntry(id, data) {
  return client.put(`/api/training/${id}/full-edit`, data);
}

export function getStatisticsTrainingRequestContext(id) {
  return client.get(`/api/training/${id}/statistics-request-context`);
}

export function createStatisticsTrainingChangeRequests(id, data) {
  return client.post(`/api/training/${id}/statistics-change-requests`, data);
}

export function getStatisticsPendingRequestContext(requestId) {
  return client.get(`/api/training/statistics-pending-requests/${requestId}/context`);
}

export function updateStatisticsPendingRequest(requestId, data) {
  return client.put(`/api/training/statistics-pending-requests/${requestId}`, data);
}

export function cancelStatisticsPendingRequest(requestId, data) {
  return client.post(`/api/training/statistics-pending-requests/${requestId}/cancel`, data);
}

export function getTrainingEntryDeleteContext(id) {
  return client.get(`/api/training/${id}/delete-context`);
}

export function groupDeleteTrainingEntry(id, data) {
  return client.post(`/api/training/${id}/group-delete`, data);
}

export function cancelTrainingChangeRequest(id, reason = '') {
  return client.post(`/api/change-requests/${id}/cancel`, { reason });
}

export function deleteTrainingHours(id, reason) {
  return client.delete(`/api/training/${id}`, { data: { reason } });
}

export function getTrainers() {
  return client.get('/api/users/trainers');
}

export function getKeywordSuggestions(params) {
  return client.get('/api/training/keyword-suggestions', { params });
}

export async function getTrainingEntryTypes(params = {}) {
  const response = await client.get('/api/training/entry-types', { params });
  return normalizeTrainingEntryTypeOptions(response.data?.options);
}

export function exportPdf(params) {
  return client.get('/api/training/export-pdf', { params, responseType: 'blob' });
}

// publicClient (no auth interceptor) — anonymous PDF return flow must surface 401s
// in-place rather than redirect to /login. Do not switch these to `client`.
export function getPublicPdfReturn(token) {
  return publicClient.get(`/api/training/export-pdf/public-return/${encodeURIComponent(token)}`);
}

export function completePublicPdfReturn(token, data) {
  return publicClient.post(`/api/training/export-pdf/public-return/${encodeURIComponent(token)}/complete`, data);
}

export function downloadPublicPdf(token) {
  return publicClient.get(`/api/training/export-pdf/public-return/${encodeURIComponent(token)}/download`, { responseType: 'blob' });
}
